export const newsletterButtonOverrides = {
  BaseButton: {
    style: {
      backgroundColor: 'orange',
      ':hover': {
        backgroundColor: 'darkorange',
      },
    },
  },
}
